import React from "react";
import * as Styled from "./styled.jsx";
import { useTheme } from "styled-components";

import world from "./assets/ic-welcome-popup.png";

function Welcome(props) {
  const theme = useTheme();

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Styled.Globe src={world} />
      <Styled.Title>
        <span style={{ color: theme.color.text.primary }}>Welcome to </span>
        <span style={{ color: theme.color.accent }}>Imversed.World!</span>
      </Styled.Title>
      <Styled.Disclaimer>Own, create, earn and dream on your own land.</Styled.Disclaimer>

      <Styled.BackgroundButton onClick={props.onExplore}>Explore New York</Styled.BackgroundButton>
      <Styled.TextButton onClick={() => openInNewTab("https://imversed.com/")}>Learn More</Styled.TextButton>
    </>
  );
}

export default Welcome;
